import React, { Suspense, useEffect, useState } from "react";
import Main from "components/Main";
import Private from "Routes/Private";
import Public from "Routes/Public";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  getAuthenticationStatus,
  getAuthenticationToken,
} from "store/selectors";
import { loginRequest, logout } from "store/actions/login";
import LoadingBar from "components/LoadingBar";
import { useLocation, useHistory } from "react-router-dom";

const Routes = () => {
  const dispatch = useDispatch();
  const { search, pathname } = useLocation();
  const history = useHistory();
  const authenticated = useSelector(getAuthenticationStatus);
  const authToken = useSelector(getAuthenticationToken);
  const [isLoading, setIsLoading] = useState(true);

  if (pathname === "/logout") {
    dispatch(logout());
  }

  useEffect(() => {
    // Set auth header whenever we have a token
    if (authToken) {
      axios.defaults.headers.common["Authorization"] = "JWT " + authToken;
    }

    // Handle authentication state
    if (authenticated === undefined) {
      // Initial loading state — try to restore the session from localStorage
      // if we have a token stored. The saga handles the rest.
      const storedToken = localStorage.getItem("token");
      if (
        storedToken &&
        pathname !== "/login" &&
        pathname !== "/resetpassword" &&
        pathname !== "/confirm-reset" &&
        pathname !== "/new-password"
      ) {
        dispatch(loginRequest());
      } else {
        // No token found, finish loading
        setIsLoading(false);
      }
    } else {
      // Authentication state is determined, finish loading
      setIsLoading(false);

      // Only redirect if not authenticated and not already on allowed public pages
      if (
        authenticated === false &&
        pathname !== "/login" &&
        pathname !== "/error" &&
        pathname !== "/resetpassword" &&
        pathname !== "/confirm-reset" &&
        pathname !== "/new-password"
      ) {
        history.push("/login");
      }
    }
  }, [authenticated, authToken, search, dispatch, pathname, history]);

  // Show loading bar while determining authentication state
  if (isLoading) {
    return <LoadingBar />;
  }

  return (
    <Suspense fallback={<LoadingBar />}>
      {authenticated === true ? (
        <Main>
          <Suspense fallback={<LoadingBar />}>
            <Private />
          </Suspense>
        </Main>
      ) : (
        <Public />
      )}
    </Suspense>
  );
};

export default Routes;
